import { StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getBankPartnerCardWidgetStyles = () => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    },
    iconContainer: {
      flexShrink: 0,
      paddingRight: tokens.spacing.SPACING_8
    },
    textContainer: {
      flex: 1
    },
    keyValueTextContainer: {
      paddingTop: spacing.SPACING_12
    },
    containerCard: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gridGap: '20px',
      width: ' 100%',
      marginTop: '12px'
    },
    partnerCardWidth: {
      width: '46%'
    },
    ctaStyles: {
      marginTop: tokens === null || tokens === void 0 ? void 0 : tokens.spacing.SPACING_8,
      alignSelf: 'center'
    }
  });
};